import { call, debounce, put } from 'redux-saga/effects';
import { REQUEST, SUCCESS, FAILURE } from '../../../../utils/actionTypeUtil';
import { AppAction } from '../../../../state/app';
import { pushNotificationMessage } from '../../../components/Notification';
import { fetchProgramAndBrandRequestList } from '../../../../services/programAndBrandRequestService';
import { FETCH_PENDING_APPROVAL_PROGRAMANDBRANDREQUEST_LIST } from './pendingApprovalProgramBrandRequestList.actions';

function* fetchPendingApprovalProgramBrandRequestListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(fetchProgramAndBrandRequestList, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchPendingApprovalProgramBrandRequestList() {
  yield debounce(
    250,
    FETCH_PENDING_APPROVAL_PROGRAMANDBRANDREQUEST_LIST,
    fetchPendingApprovalProgramBrandRequestListSaga,
  );
}
